export const isSchoolHours = (date?: Date) => {
  const currentDate = date || new Date();
  const weekday = currentDate.getDay();
  const hour = currentDate.getHours();

  if (weekday === 0 || weekday === 6) {
    return false;
  } else if (weekday === 3 && hour >= 13) {
    return false;
  } else if (hour >= 17) {
    return false;
  }
  return true;
};
